var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "on-return": _vm.back,
          page: _vm.pageConfig
        }
      }),
      _c("board", { staticClass: "mb-4", attrs: { details: _vm.boardData } }),
      _c(
        "validation-observer",
        {
          ref: "admissionManagementRef",
          attrs: { novalidate: "", tag: "form" }
        },
        [
          _vm.isSignHubActive
            ? _c(
                "b-tabs",
                {
                  staticClass: "mt-3",
                  attrs: {
                    "nav-class": "custom-nav-container",
                    "no-nav-style": ""
                  }
                },
                [
                  _c(
                    "b-tab",
                    { attrs: { active: "", title: "Informe de Alta/Baja" } },
                    [
                      _c(
                        "div",
                        { staticClass: "my-4" },
                        [
                          _c("section-title", {
                            attrs: {
                              "has-line": "",
                              title: "Mantenimiento de Admisión"
                            }
                          }),
                          _c("div", { staticClass: "row ml-2 pr-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-3 mt-1" },
                              [
                                _c("validation-provider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "color-secondary-6 font-14"
                                              },
                                              [_vm._v(" Nivel: ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "bg-gray-9 p-2 rounded mt-2"
                                              },
                                              [
                                                _c("custom-radio", {
                                                  attrs: {
                                                    "container-class":
                                                      "d-flex justify-content-between",
                                                    "is-disabled":
                                                      _vm.isReadOnly,
                                                    "is-inline": "",
                                                    name: "rbType",
                                                    options: _vm.rbOptions
                                                  },
                                                  on: {
                                                    input: _vm.onLevelChange
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model.selectedLevel,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "selectedLevel",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.selectedLevel"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c("error", {
                                                  attrs: {
                                                    message:
                                                      "Favor seleccionar el nivel.",
                                                    variant: "no-border"
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2109013878
                                  )
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-md-2" },
                              [
                                _c("validation-provider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-date-picker", {
                                              staticClass: "w-100",
                                              attrs: {
                                                "custom-error-msg":
                                                  "Favor seleccionar la fecha de efectividad.",
                                                disabled: _vm.isReadOnly,
                                                error: errors[0],
                                                label: "Efectivo:",
                                                "max-date": _vm.maxDate,
                                                "min-date": _vm.minDate,
                                                placeholder: "DD/MM/YYYY"
                                              },
                                              model: {
                                                value: _vm.model.effectiveDate,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "effectiveDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "model.effectiveDate"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    377497732
                                  )
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-md-2" },
                              [
                                _c("validation-provider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-date-picker", {
                                              staticClass: "w-100",
                                              attrs: {
                                                "custom-error-msg":
                                                  "Favor seleccionar la fecha discusión minuta.",
                                                disabled: _vm.isReadOnly,
                                                error: errors[0],
                                                label:
                                                  "Fecha Discusión Minuta:",
                                                "max-date": _vm.maxDate,
                                                "min-date": _vm.minDate,
                                                placeholder: "DD/MM/YYYY"
                                              },
                                              model: {
                                                value:
                                                  _vm.model
                                                    .discussionMinutesDate,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "discussionMinutesDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "model.discussionMinutesDate"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    765389275
                                  )
                                })
                              ],
                              1
                            ),
                            _c("div", { staticClass: "col-md-5" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-end" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex-grow-1" },
                                    [
                                      _c("validation-provider", {
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ errors }) {
                                                return [
                                                  _c("custom-drop-down", {
                                                    attrs: {
                                                      "custom-error-msg":
                                                        "Favor seleccionar la razón.",
                                                      disabled: _vm.isReadOnly,
                                                      error: errors[0],
                                                      fieldkey: "id",
                                                      fieldname: "name",
                                                      label: "Razón:",
                                                      options: _vm.reasons,
                                                      placeholder: "Seleccione"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.model
                                                          .selectedReason,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "selectedReason",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.selectedReason"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          644548100
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm.showReasonComment
                                ? _c(
                                    "div",
                                    {},
                                    [
                                      _c("validation-provider", {
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ errors }) {
                                                return [
                                                  _c("custom-text-area", {
                                                    attrs: {
                                                      id:
                                                        "txtCommentDenyPayment",
                                                      "custom-error-msg":
                                                        "Favor escribir un comentario.",
                                                      disabled: _vm.isReadOnly,
                                                      error: errors[0],
                                                      label:
                                                        "Razón que limita el ofrecimiento:",
                                                      maxlength: 500,
                                                      "show-char-count": ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.model
                                                          .dropReasonComment,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "dropReasonComment",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.dropReasonComment"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3426012053
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-12 mt-4" }, [
                            _vm.showRecommendationsComment
                              ? _c(
                                  "div",
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-text-area", {
                                                  attrs: {
                                                    id:
                                                      "txtRecommendationsComment",
                                                    "count-classes": [
                                                      "d-block",
                                                      "small-counter",
                                                      "text-right"
                                                    ],
                                                    "custom-error-msg":
                                                      "Favor de documentar las recomendaciones para la escuela y hogar.",
                                                    disabled: _vm.isReadOnly,
                                                    error: errors[0],
                                                    label:
                                                      "Recomendaciones para la escuela y hogar (plan de seguimiento):",
                                                    maxlength: 3000,
                                                    "show-char-count": ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model
                                                        .recommendationsComment,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "recommendationsComment",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.recommendationsComment"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2704037620
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _c("div", { staticClass: "col-md-12 mt-4" }, [
                            _c(
                              "div",
                              [
                                _c("validation-provider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-text-area", {
                                              attrs: {
                                                id: "txtResult",
                                                "count-classes": [
                                                  "d-block",
                                                  "small-counter",
                                                  "text-right"
                                                ],
                                                "custom-error-msg":
                                                  "Favor escribir los resultados.",
                                                disabled: _vm.isReadOnly,
                                                error: errors[0],
                                                label: "Resultados:",
                                                maxlength: 3000,
                                                "show-char-count": ""
                                              },
                                              model: {
                                                value: _vm.model.results,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "results",
                                                    $$v
                                                  )
                                                },
                                                expression: "model.results"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2597357385
                                  )
                                })
                              ],
                              1
                            )
                          ]),
                          _vm.showLocationFields
                            ? _c("div", { staticClass: "row mt-3 ml-2" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("hr")
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-drop-down", {
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "Favor seleccionar municipio.",
                                                    error: errors[0],
                                                    fieldkey: "id",
                                                    fieldname: "name",
                                                    label: "Municipio:",
                                                    options: _vm.municipalities,
                                                    placeholder: "Seleccione"
                                                  },
                                                  on: {
                                                    input:
                                                      _vm.onMunicipalityChange
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model
                                                        .selectedMunicipality,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "selectedMunicipality",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.selectedMunicipality"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1409845776
                                      )
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-drop-down", {
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "Favor seleccionar lugar de servicio.",
                                                    error: errors[0],
                                                    fieldkey: "id",
                                                    fieldname: "name",
                                                    label: "Lugar de Servicio:",
                                                    options: _vm.locations,
                                                    placeholder: "Seleccione"
                                                  },
                                                  on: {
                                                    input: _vm.onLocationChange
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model
                                                        .selectedLocation,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "selectedLocation",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.selectedLocation"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1157197172
                                      )
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-drop-down", {
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "Favor seleccionar especialista.",
                                                    error: errors[0],
                                                    fieldkey: "id",
                                                    fieldname: "name",
                                                    label: "Especialista:",
                                                    options: _vm.specialists,
                                                    placeholder: "Seleccione"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model
                                                        .selectedSpecialist,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "selectedSpecialist",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.selectedSpecialist"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        483756787
                                      )
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          !_vm.showLocationFields
                            ? _c(
                                "div",
                                { staticClass: "mt-5" },
                                [
                                  _c("section-title", {
                                    attrs: {
                                      "has-line": "",
                                      title: "Documentos Anejados"
                                    }
                                  }),
                                  _vm._l(_vm.requiredDocuments, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: `document-row-${index}`,
                                        staticClass:
                                          "row bg-secondary-3 rounded p-3 mb-3 ml-1 mr-0"
                                      },
                                      [
                                        _c("div", { staticClass: "col-md-6" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "color-gray-6 font-14 font-weight-normal"
                                            },
                                            [_vm._v(" Tipo de Documento: ")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "color-black font-16 font-weight-normal"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.documentTypeName
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-6 d-flex justify-content-end"
                                          },
                                          [
                                            _vm.isDropTypeDocument(item)
                                              ? _c("div", [
                                                  _vm.hasDownloadedAdmissionTemplate
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Documento: "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "validation-provider",
                                                            {
                                                              attrs: {
                                                                rules: {
                                                                  required:
                                                                    item.isRequired
                                                                }
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function({
                                                                      errors
                                                                    }) {
                                                                      return [
                                                                        _c(
                                                                          "custom-file-input",
                                                                          {
                                                                            ref:
                                                                              "attachedDocument",
                                                                            refInFor: true,
                                                                            attrs: {
                                                                              accept:
                                                                                ".pdf",
                                                                              "attachment-id":
                                                                                item.documentId,
                                                                              "custom-error-msg":
                                                                                "Favor de anejar un documento.",
                                                                              "display-style":
                                                                                "normal",
                                                                              error:
                                                                                errors[0],
                                                                              "label-position":
                                                                                "left",
                                                                              required:
                                                                                ""
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                item.selectedDocument,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  item,
                                                                                  "selectedDocument",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "item.selectedDocument"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "div",
                                                        [
                                                          _c("action-button", {
                                                            staticClass:
                                                              "bg-green border-green mt-1",
                                                            attrs: {
                                                              id:
                                                                "admission-drop-type-template" +
                                                                index,
                                                              i:
                                                                "fas fa-file-download text-white mr-n1 pr-1"
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.downloadAdmissionDropTypeTemplate
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                ])
                                              : _c("div", [
                                                  !item.isEditing &&
                                                  _vm.model.documents.some(
                                                    x =>
                                                      x.documentTypeId ==
                                                      item.documentTypeId
                                                  )
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c("action-button", {
                                                            staticClass:
                                                              "bg-green border-green mt-1 mr-2",
                                                            attrs: {
                                                              i:
                                                                "fas fa-file-download text-white mr-n1 pr-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.downloadFileByType(
                                                                  item.documentTypeId
                                                                )
                                                              }
                                                            }
                                                          }),
                                                          _vm.isEditing
                                                            ? _c(
                                                                "action-button",
                                                                {
                                                                  staticClass:
                                                                    "bg-green border-green mt-1",
                                                                  attrs: {
                                                                    i:
                                                                      "fas fa-edit text-white mr-n1"
                                                                  },
                                                                  on: {
                                                                    click: () =>
                                                                      (item.isEditing = true)
                                                                  }
                                                                }
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Documento: "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "validation-provider",
                                                            {
                                                              attrs: {
                                                                rules: {
                                                                  required:
                                                                    item.isRequired
                                                                }
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function({
                                                                      errors
                                                                    }) {
                                                                      return [
                                                                        _c(
                                                                          "custom-file-input",
                                                                          {
                                                                            ref:
                                                                              "attachedDocument",
                                                                            refInFor: true,
                                                                            attrs: {
                                                                              accept:
                                                                                ".pdf",
                                                                              "attachment-id":
                                                                                item.documentId,
                                                                              "custom-error-msg":
                                                                                "Favor de anejar un documento.",
                                                                              "display-style":
                                                                                "normal",
                                                                              error:
                                                                                errors[0],
                                                                              "label-position":
                                                                                "left",
                                                                              required:
                                                                                ""
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                item.selectedDocument,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  item,
                                                                                  "selectedDocument",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "item.selectedDocument"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                ])
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _vm.showSignTab && !_vm.isEditing
                    ? _c("b-tab", { attrs: { title: "Firmas" } }, [
                        _c(
                          "div",
                          { staticClass: "my-4" },
                          [
                            _c("sign-plan", {
                              key: _vm.admissionId,
                              ref: "signPlanRef",
                              attrs: {
                                disabled: _vm.isElectronicDisabled,
                                "is-electronic-signature":
                                  _vm.model.isElectronicSignature,
                                "question-label":
                                  "¿Cuál será el mecanismo que se estará utilizando para firmar la Informe de Alta/Baja?"
                              },
                              on: {
                                "update:isElectronicSignature": function(
                                  $event
                                ) {
                                  return _vm.$set(
                                    _vm.model,
                                    "isElectronicSignature",
                                    $event
                                  )
                                },
                                "update:is-electronic-signature": function(
                                  $event
                                ) {
                                  return _vm.$set(
                                    _vm.model,
                                    "isElectronicSignature",
                                    $event
                                  )
                                }
                              }
                            }),
                            _c(
                              "div",
                              { staticClass: "mt-4" },
                              [
                                _vm.hasSelectMechanisManuscript
                                  ? _c(
                                      "div",
                                      [
                                        _c("section-title", {
                                          attrs: {
                                            "has-line": "",
                                            title: "Documento"
                                          }
                                        }),
                                        _vm.highLowInformDocument
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row bg-secondary-3 rounded p-3 mb-3 ml-1 mr-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-md-6" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "color-gray-6 font-14 font-weight-normal"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Tipo de Documento: "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "color-black font-16 font-weight-normal"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm
                                                                .highLowInformDocument
                                                                .documentTypeName
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-md-6 d-flex justify-content-end"
                                                  },
                                                  [
                                                    _vm.hasManuscriptDocUploaded
                                                      ? _c("action-button", {
                                                          staticClass:
                                                            "bg-green border-green mt-1",
                                                          attrs: {
                                                            i:
                                                              "fas fa-file-download text-white mr-n1 pr-1"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.downloadFileByType(
                                                                _vm
                                                                  .highLowInformDocument
                                                                  .documentTypeId
                                                              )
                                                            }
                                                          }
                                                        })
                                                      : _vm.hasDownloadedAdmissionTemplate
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Documento: "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "validation-provider",
                                                              {
                                                                attrs: {
                                                                  rules: {
                                                                    required: true
                                                                  }
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "default",
                                                                      fn: function({
                                                                        errors
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "custom-file-input",
                                                                            {
                                                                              ref:
                                                                                "highLowInform",
                                                                              attrs: {
                                                                                accept:
                                                                                  ".pdf",
                                                                                "attachment-id":
                                                                                  _vm
                                                                                    .highLowInformDocument
                                                                                    .documentId,
                                                                                "custom-error-msg":
                                                                                  "Favor de anejar un documento.",
                                                                                "display-style":
                                                                                  "normal",
                                                                                error:
                                                                                  errors[0],
                                                                                "label-position":
                                                                                  "left",
                                                                                required:
                                                                                  ""
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  _vm
                                                                                    .highLowInformDocument
                                                                                    .selectedDocument,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.highLowInformDocument,
                                                                                    "selectedDocument",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "highLowInformDocument.selectedDocument"
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      }
                                                                    }
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  2261184407
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _c("action-button", {
                                                          staticClass:
                                                            "bg-green border-green mt-1",
                                                          attrs: {
                                                            i:
                                                              "fas fa-file-download text-white mr-n1 pr-1"
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.downloadAdmissionDropTypeTemplate
                                                          }
                                                        })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm.hasSelectMechanismElectronic
                                  ? _c("signature-hub-info", {
                                      attrs: {
                                        "signature-info": _vm.signatureHubInfo
                                      },
                                      on: {
                                        "configure-sign":
                                          _vm.handleConfigureSignatures
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("section-title", {
                    attrs: {
                      "has-line": "",
                      title: "Mantenimiento de Admisión"
                    }
                  }),
                  _c("div", { staticClass: "row ml-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3 mt-1" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "color-secondary-6 font-14"
                                    },
                                    [_vm._v(" Nivel: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "bg-gray-9 p-2 rounded mt-2"
                                    },
                                    [
                                      _c("custom-radio", {
                                        attrs: {
                                          "container-class":
                                            "d-flex justify-content-between",
                                          "is-inline": "",
                                          name: "rbType",
                                          options: _vm.rbOptions
                                        },
                                        on: { input: _vm.onLevelChange },
                                        model: {
                                          value: _vm.model.selectedLevel,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "selectedLevel",
                                              $$v
                                            )
                                          },
                                          expression: "model.selectedLevel"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  errors[0]
                                    ? _c("error", {
                                        attrs: {
                                          message:
                                            "Favor seleccionar el nivel.",
                                          variant: "no-border"
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-date-picker", {
                                    staticClass: "w-100",
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor seleccionar la fecha de efectividad.",
                                      error: errors[0],
                                      label: "Efectivo:",
                                      "max-date": _vm.maxDate,
                                      "min-date": _vm.minDate,
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    model: {
                                      value: _vm.model.effectiveDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "effectiveDate",
                                          $$v
                                        )
                                      },
                                      expression: "model.effectiveDate"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-date-picker", {
                                    staticClass: "w-100",
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor seleccionar la fecha discusión minuta.",
                                      error: errors[0],
                                      label: "Fecha Discusión Minuta:",
                                      "max-date": _vm.maxDate,
                                      "min-date": _vm.minDate,
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    model: {
                                      value: _vm.model.discussionMinutesDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "discussionMinutesDate",
                                          $$v
                                        )
                                      },
                                      expression: "model.discussionMinutesDate"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-5" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor seleccionar la razón.",
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Razón:",
                                      options: _vm.reasons,
                                      placeholder: "Seleccione"
                                    },
                                    model: {
                                      value: _vm.model.selectedReason,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "selectedReason",
                                          $$v
                                        )
                                      },
                                      expression: "model.selectedReason"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _vm.showReasonComment
                      ? _c(
                          "div",
                          { staticClass: "col-md-5 offset-md-5 mt-1" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-text-area", {
                                          attrs: {
                                            id: "txtCommentDenyPayment",
                                            "custom-error-msg":
                                              "Favor escribir un comentario.",
                                            error: errors[0],
                                            label:
                                              "Razón que limita el ofrecimiento:",
                                            maxlength: 500,
                                            "show-char-count": ""
                                          },
                                          model: {
                                            value: _vm.model.dropReasonComment,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "dropReasonComment",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "model.dropReasonComment"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1179889455
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showRecommendationsComment
                      ? _c(
                          "div",
                          { staticClass: "col-md-12 mt-4" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-text-area", {
                                          attrs: {
                                            id: "txtRecommendationsComment",
                                            "count-classes": [
                                              "d-block",
                                              "small-counter",
                                              "text-right"
                                            ],
                                            "custom-error-msg":
                                              "Favor de documentar las recomendaciones para la escuela y hogar.",
                                            error: errors[0],
                                            label:
                                              "Recomendaciones para la escuela y hogar (plan de seguimiento):",
                                            maxlength: 3000,
                                            "show-char-count": ""
                                          },
                                          model: {
                                            value:
                                              _vm.model.recommendationsComment,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "recommendationsComment",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "model.recommendationsComment"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2950457614
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-md-12 mt-4" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-text-area", {
                                    attrs: {
                                      id: "txtResult",
                                      "count-classes": [
                                        "d-block",
                                        "small-counter",
                                        "text-right"
                                      ],
                                      "custom-error-msg":
                                        "Favor escribir los resultados.",
                                      error: errors[0],
                                      label: "Resultados:",
                                      maxlength: 3000,
                                      "show-char-count": ""
                                    },
                                    model: {
                                      value: _vm.model.results,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "results", $$v)
                                      },
                                      expression: "model.results"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ]),
                  _vm.showLocationFields
                    ? _c("div", { staticClass: "row mt-3 ml-2" }, [
                        _c("div", { staticClass: "col-md-12" }, [_c("hr")]),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Favor seleccionar municipio.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            label: "Municipio:",
                                            options: _vm.municipalities,
                                            placeholder: "Seleccione"
                                          },
                                          on: {
                                            input: _vm.onMunicipalityChange
                                          },
                                          model: {
                                            value:
                                              _vm.model.selectedMunicipality,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "selectedMunicipality",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "model.selectedMunicipality"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1409845776
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Favor seleccionar lugar de servicio.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            label: "Lugar de Servicio:",
                                            options: _vm.locations,
                                            placeholder: "Seleccione"
                                          },
                                          on: { input: _vm.onLocationChange },
                                          model: {
                                            value: _vm.model.selectedLocation,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "selectedLocation",
                                                $$v
                                              )
                                            },
                                            expression: "model.selectedLocation"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1157197172
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Favor seleccionar especialista.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            label: "Especialista:",
                                            options: _vm.specialists,
                                            placeholder: "Seleccione"
                                          },
                                          model: {
                                            value: _vm.model.selectedSpecialist,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "selectedSpecialist",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "model.selectedSpecialist"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                483756787
                              )
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  !_vm.showLocationFields
                    ? _c(
                        "div",
                        { staticClass: "mt-5" },
                        [
                          _c("section-title", {
                            attrs: {
                              "has-line": "",
                              title: "Documentos Anejados"
                            }
                          }),
                          _vm._l(_vm.requiredDocuments, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: `document-row-${index}`,
                                staticClass:
                                  "row bg-secondary-3 rounded p-3 mb-3 ml-1 mr-0"
                              },
                              [
                                _c("div", { staticClass: "col-md-6" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal"
                                    },
                                    [_vm._v(" Tipo de Documento: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-normal"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.documentTypeName) +
                                          " "
                                      )
                                    ]
                                  )
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-6 d-flex justify-content-center"
                                  },
                                  [
                                    _vm.isDropTypeDocument(item)
                                      ? _c("div", [
                                          _vm.hasDownloadedAdmissionTemplate
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                                                    },
                                                    [_vm._v(" Documento: ")]
                                                  ),
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: {
                                                        required:
                                                          item.isRequired
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function({
                                                            errors
                                                          }) {
                                                            return [
                                                              _c(
                                                                "custom-file-input",
                                                                {
                                                                  ref:
                                                                    "attachedDocument",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    accept:
                                                                      ".pdf",
                                                                    "attachment-id":
                                                                      item.documentId,
                                                                    "custom-error-msg":
                                                                      "Favor de anejar un documento.",
                                                                    "display-style":
                                                                      "normal",
                                                                    error:
                                                                      errors[0],
                                                                    "label-position":
                                                                      "left",
                                                                    required: ""
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.selectedDocument,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        item,
                                                                        "selectedDocument",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "item.selectedDocument"
                                                                  }
                                                                }
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c("action-button", {
                                                    staticClass:
                                                      "bg-green border-green mt-1",
                                                    attrs: {
                                                      id:
                                                        "admission-drop-type-template" +
                                                        index,
                                                      i:
                                                        "fas fa-file-download text-white mr-n1 pr-1"
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.downloadAdmissionDropTypeTemplate
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                        ])
                                      : _c(
                                          "div",
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                                              },
                                              [_vm._v(" Documento: ")]
                                            ),
                                            _c("validation-provider", {
                                              attrs: {
                                                rules: {
                                                  required: item.isRequired
                                                }
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c(
                                                          "custom-file-input",
                                                          {
                                                            ref:
                                                              "attachedDocument",
                                                            refInFor: true,
                                                            attrs: {
                                                              accept: ".pdf",
                                                              "attachment-id":
                                                                item.documentId,
                                                              "custom-error-msg":
                                                                "Favor de anejar un documento.",
                                                              "display-style":
                                                                "normal",
                                                              error: errors[0],
                                                              "label-position":
                                                                "left",
                                                              required: ""
                                                            },
                                                            model: {
                                                              value:
                                                                item.selectedDocument,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "selectedDocument",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.selectedDocument"
                                                            }
                                                          }
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                  ]
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }